import { FooterProps } from './Footer';

export const isFooterType = (footerData: any): footerData is FooterProps =>
  footerData !== null && footerData.component === 'footer';
